import { Avatar,Tooltip } from '@material-ui/core'
import { GitHub } from '@material-ui/icons'
import React, { Component, Fragment } from 'react'

export default class ProjectsItem extends Component {
    render() {
        return (
            <Fragment>
                <div className="m-2 rounded-sm position-relative p-2" style={{width:300,minHeight:200,backgroundColor:this.props.mode?"rgba(255,255,255,0.2)":"rgba(0,0,0,0.5)"}}>
                    <div className="d-flex container justify-content-between align-items-center">
                        <h6 className="text-white text-lato font-weight-lighter">@{this.props.when}</h6>
                        {/* <span className="d-block btn btn-sm rounded-pill bg-muted btn-effect text-center d-flex justify-content-center align-items-center text-white font-weight-bolder" style={{height:25}}>News</span> */}
                    </div>
                    <div className="container py-1">
                        <h5 className="text-white text-lato">{this.props.text}</h5>
                    </div>
                    <div className="container position-absolute d-flex justify-content-between align-items-center" style={{bottom:5}}>
                        <Tooltip title={this.props.language==="en"?"My Github":"Mon Github"} arrow placement="top">
                            <a target="_blank" style={{boxShadow:"none"}} href={this.props.link} className=" btn btn-sm rounded-sm btn-effect text-white" rel="noreferrer"><GitHub/> {this.props.language==="en"?"LEARN MORE":"LIRE PLUS"}</a>
                        </Tooltip>
                        <Avatar src={this.props.img} center/>
                    </div>
                </div>
            </Fragment>
        )
    }
}
